var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", [
    _c("header", { staticClass: "m-0 mb-6" }, [
      _c("h1", { staticClass: "fs-32 m-0" }, [
        _vm._v(_vm._s(_vm.$l10n.__("Finalisez votre abonnement")))
      ])
    ]),
    _vm._v(" "),
    _c(
      "article",
      { staticClass: "mt-6" },
      [
        _c("header", [
          _c("h2", { staticClass: "m-0" }, [
            _vm._v(_vm._s(_vm.$l10n.__("Informations de contact")))
          ])
        ]),
        _vm._v(" "),
        _c(
          "card",
          {
            staticClass:
              "card-contact mt-5 b-1-gray-05 flex-row br fs-3 flex-top",
            attrs: { background: "lightgrey" }
          },
          [
            _c("ul", { staticClass: "my-0 gray-60 semibold unstyled" }, [
              _c("li", { staticClass: "mb-2" }, [
                _vm._v(_vm._s(_vm.$l10n.__("Prénom et Nom")))
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "mb-2" }, [
                _vm._v(_vm._s(_vm.$l10n.__("Email")))
              ]),
              _vm._v(" "),
              _c("li", [_vm._v(_vm._s(_vm.$l10n.__("Téléphone")))])
            ]),
            _vm._v(" "),
            _c("ul", { staticClass: "ml-5 my-0 unstyled" }, [
              _c("li", { staticClass: "mb-2 gray-100" }, [
                _vm._v(
                  _vm._s(_vm.contact.forename) + " " + _vm._s(_vm.contact.name)
                )
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "mb-2 gray-100" }, [
                _vm._v(_vm._s(_vm.contact.email))
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "gray-100" }, [
                _vm._v(_vm._s(_vm.contact.phone.e164))
              ])
            ])
          ]
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("span", { staticClass: "separator block my-6" }),
    _vm._v(" "),
    _c(
      "article",
      [
        _c("h2", { staticClass: "mt-0 mb-5" }, [
          _vm._v(_vm._s(_vm.$l10n.__("Informations de facturation")))
        ]),
        _vm._v(" "),
        _c(
          "card",
          {
            staticClass:
              "card-contact mt-5 flex-column br b-1-gray-05 fs-3 flex-top",
            attrs: { background: "lightgrey" }
          },
          [
            _c("div", { staticClass: "info-wrapper" }, [
              _c("p", { staticClass: "w-200 gray-60 semibold" }, [
                _vm._v(_vm._s(_vm.$l10n.__("Nom de l'entreprise")))
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "gray-100" }, [
                _vm._v(_vm._s(_vm.corpName))
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "info-wrapper" }, [
              _c("p", { staticClass: "w-200 gray-60 semibold" }, [
                _vm._v(_vm._s(_vm.$l10n.__("Adresse postale")))
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "flex-column gray-100" }, [
                _c("span", [_vm._v(_vm._s(_vm.billingSettings.line1))]),
                _vm._v(" "),
                _vm.billingSettings.line2
                  ? _c("span", [_vm._v(_vm._s(_vm.billingSettings.line2))])
                  : _vm._e(),
                _vm._v(" "),
                _vm.billingSettings.line3
                  ? _c("span", [_vm._v(_vm._s(_vm.billingSettings.line3))])
                  : _vm._e(),
                _vm._v(" "),
                _vm.billingSettings.line4
                  ? _c("span", [_vm._v(_vm._s(_vm.billingSettings.line4))])
                  : _vm._e(),
                _vm._v(" "),
                _vm.billingSettings.state
                  ? _c("span", [_vm._v(_vm._s(_vm.billingSettings.state))])
                  : _vm._e(),
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    _vm._s(_vm.billingSettings.postalCode) +
                      " " +
                      _vm._s(_vm.billingSettings.city)
                  )
                ]),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.billingSettings.country))])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "info-wrapper" }, [
              _c("p", { staticClass: "w-200 gray-60 semibold" }, [
                _vm._v(_vm._s(_vm.$l10n.__("Langue de facturation")))
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "gray-100" }, [
                _vm._v(_vm._s(_vm.billingLocale.name))
              ])
            ]),
            _vm._v(" "),
            _vm.vatIntra
              ? _c("div", { staticClass: "info-wrapper" }, [
                  _c("p", { staticClass: "w-200 gray-60 semibold" }, [
                    _vm._v(_vm._s(_vm.$l10n.__("N° TVA intracommunautaire")))
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "gray-100" }, [
                    _vm._v(_vm._s(_vm.vatIntra))
                  ])
                ])
              : _vm._e()
          ]
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("span", { staticClass: "separator block my-6" }),
    _vm._v(" "),
    _c(
      "article",
      [
        _c("header", { staticClass: "flex-row ai-center" }, [
          _c("h2", { staticClass: "my-0" }, [
            _vm._v(_vm._s(_vm.$l10n.__("Informations de paiement")))
          ]),
          _vm._v(" "),
          _vm.isCardMethod
            ? _c("span", { staticClass: "gray-60 fs-2 flex-item-right" }, [
                _c("i", { staticClass: "icon-lock-fillout" }),
                _vm._v(" " + _vm._s(_vm.$l10n.__("Paiement sécurisé SSL")))
              ])
            : _vm._e()
        ]),
        _vm._v(" "),
        _vm.isCardMethod
          ? _c("cart-stripe-form", { attrs: { isPublic: true } })
          : _vm._e(),
        _vm._v(" "),
        _vm.isManualMethod
          ? _c(
              "div",
              [
                _c("p", { staticClass: "gray-100" }, [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$l10n.__(
                          "Merci d’effectuer un virement du montant de votre abonnement vers le compte ci-dessous. À réception du virement nous procéderons à l’activation de votre compte."
                        )
                      )
                  )
                ]),
                _vm._v(" "),
                _c(
                  "card",
                  {
                    staticClass:
                      "mt-3 flex-column br b-1-gray-05 fs-3 flex-top",
                    attrs: { background: "lightgrey" }
                  },
                  [
                    _c("div", { staticClass: "info-wrapper mb-2" }, [
                      _c(
                        "p",
                        { staticClass: "w-160 semibold m-0 fs-3 gray-60" },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$filters.capitalize(
                                _vm.$l10n.__("Titulaire du compte")
                              )
                            )
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("p", { staticClass: "m-0 fs-3 gray-100" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$filters.capitalize(
                              _vm.SellsyBankInfos.accountOwner
                            )
                          )
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "info-wrapper mb-2" }, [
                      _c(
                        "p",
                        { staticClass: "w-160 semibold m-0 fs-3 gray-60" },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$filters.capitalize(_vm.$l10n.__("IBAN"))
                            )
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("p", { staticClass: "m-0 fs-3 gray-100" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$filters.capitalize(_vm.SellsyBankInfos.iban)
                          )
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "info-wrapper" }, [
                      _c(
                        "p",
                        { staticClass: "w-160 semibold m-0 fs-3 gray-60" },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$filters.capitalize(
                                _vm.$l10n.__("BIC (International Code)")
                              )
                            )
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("p", { staticClass: "m-0 fs-3 gray-100" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$filters.capitalize(_vm.SellsyBankInfos.bic)
                          )
                        )
                      ])
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("p", {
                  staticClass: "mt-3 gray-60",
                  domProps: { innerHTML: _vm._s(_vm.helpEmail) }
                })
              ],
              1
            )
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }